import React from "react";
import "./App.scss";

import {BrowserRouter as Router, Route, Switch} from "react-router-dom";

import Main from "./containers/Main";

import ArtVerseReport from "./reports/ArtVerseReport";
import BiasMapReport from "./reports/BiasMapReport";
import DiffusionReport from "./reports/DiffusionReport";
import FallDetectionReport from "./reports/FallDetectionReport";

function App() {
  return (
    <Router>
      <Switch>
        {/* Main Portfolio Home */}
        <Route exact path="/" component={Main} />

        {/* Full Reports */}
        <Route path="/artverse-report" component={ArtVerseReport} />
        <Route path="/biasmap-report" component={BiasMapReport} />
        <Route path="/diffusion-report" component={DiffusionReport} />
        <Route path="/fall-detection-report" component={FallDetectionReport} />
      </Switch>
    </Router>
  );
}

export default App;
